import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';
import { WebSocketProvider } from './WebSocketContext';
import { LicenseInfo } from '@mui/x-license';

LicenseInfo.setLicenseKey('5f0e76ccf3e06413601e717ded203f94Tz05Mzc5MixFPTE3NTE4NzMzOTQwMDAsUz1wcm8sTE09cGVycGV0dWFsLEtWPTI=');
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <WebSocketProvider>
      <App />
    </WebSocketProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
